<template>
  <div :id="this.id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="LineVComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)">

    <vue-draggable-resizable v-bind:h="parseInt(internal_config.height)" v-bind:w="10"
                             @resizing="onResize" :draggable="false" ref="draggableResizable">
      <rotate :target="this.$refs.draggableResizable" :config="this.internal_config" />
      <sync-drag :target="this" />
      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-LineVComponent'></options-element-bar>
      <div class="container-line-ver">
        <div class="arrow arrow-top" v-if="internal_config.arrowTop.active" :style="styleArrowTop()"></div>
        <div :config-properties="JSON.stringify(internal_config)" class=" sitebuilder-element"
             v-bind:style="{'border-radius': radius, 'border-left' : border, 'box-shadow': boxShadow}"></div>
        <div class="arrow arrow-bottom" v-if="internal_config.arrowBottom.active" :style="styleArrowBottom()"></div>
      </div>


      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>
  </div>
</template>

<script>

	import Model from './Model';
	import Resources from './Resources.vue';
  import OptionsElementBar from "../OptionsElementBar";
  import MixinComponents from "../../../../js/mixins/MixinComponents";

  export default {
    name: 'LineVComponent',
    props: ['config', 'src', 'id', 'preview'],
    mixins: [MixinComponents],
    components: {
      OptionsElementBar,
      Resources,
    },
    computed: {},
    data() {
      return Model.data();
    },
    watch: {
      'internal_config': {
        deep: true,
        handler(value) {
          this.$eventHub.setValueElementConfig(this.id, value);
          this.$eventPointer.log(this.id, value);
        }
      },
    },

    methods: {

      animation() {
        return true;
      },

      onResize: function (x, y, width, height) {
        this.internal_config.width = width + 'px';
        this.internal_config.height = height + 'px';

        this.$refs.resourcesData.setValuesData(this);
      },

      showResources() {
        return this.$refs.resourcesData.getValuesData();
      },

      build(config) {
        this.internal_config = config;
      },

      style() {
        var style = `height: ${this.internal_config.height} !important;
                     z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     left:  ${this.internal_config.left};
                     top: ${this.internal_config.top}`;
        return style;
      },
      styleArrowTop() {

        var style = `border-left-width: ${this.internal_config.arrowTop.size}px;
                     border-right-width: ${this.internal_config.arrowTop.size}px;
                     left: calc(50% - ${this.internal_config.arrowTop.size}px);
                     border-bottom-width: ${this.internal_config.arrowTop.size}px;
                     top: -${this.internal_config.arrowTop.size}px;
                     border-bottom-color: ${this.internal_config.arrowTop.color};`;
        return style;
      },
      styleArrowBottom() {

        var style = `border-left-width: ${this.internal_config.arrowBottom.size}px;
                     border-right-width: ${this.internal_config.arrowBottom.size}px;
                     left: calc(50% - ${this.internal_config.arrowBottom.size}px);
                     border-top-width: ${this.internal_config.arrowBottom.size}px;
                     border-top-color: ${this.internal_config.arrowBottom.color};`;
        return style;
      },
      styleResize() {
        return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
      },
    },
    created() {
      this.build(this.$props.config);
    },
    mounted() {
      this.internal_config = window.mergeRecursive(this.props, this.$props.config);

      if (this.$props.preview) {
        this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
      }

      let objIds = [];
      $('[id]').each(function () {
        var ids = $('[id="' + this.id + '"]');
        if (ids.length > 1 && ids[0] == this && parseInt(this.id))
          objIds.push(this.id);
      });
      if (objIds.includes(this.id)) {
        this.id = Date.now() + parseInt(Math.random() * 10000);
      }

      this.$root.$on('setConfigElement', (id, obj) => {
        if (this.id == id) {
          this.config = obj;
          this.internal_config = obj;
        }
      });

      this.$refs.resourcesData.setValuesData(this);
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  [data-device="desktop"] [element="LineVComponent"] .vdr {
    padding-right: 15px !important;
    padding-left: 15px !important;
    height: inherit !important;
  }

  [element="LineVComponent"] .vdr {
    height: 100% !important;
  }

  .container-line-ver {
    position: relative;
    width: 100%;
    height: 100%;

    .sitebuilder-element {
      width: 1px;
      height: 100%;

    }
  }

  .arrow {
    position: absolute;
    width: 0;
    height: 0;
  }

  .arrow-top {
    border-left-color: transparent;
    border-left-style: solid;
    border-right-color: transparent;
    border-right-style: solid;

    border-bottom-style: solid;
    right: 0;
  }

  .arrow-bottom {
    border-left-color: transparent;
    border-left-style: solid;
    border-right-color: transparent;
    border-right-style: solid;

    border-top-style: solid;
  }

</style>
<style scoped lang="scss">

  .resizable.vdr {
    height: 100% !important;
    width: auto !important;
    left: 0 !important;
    top: 0 !important;

  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/LineV/LineV.vue